//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    imprint: {
      type: String,
      default: "/en/imprint",
    },
    dataPrivacy: {
      type: String,
      default: "/en/data-privacy",
    },
    podcast: {
      type: String,
      default: "https://www.techcast.tv/de",
    },
    youtube: {
      type: String,
      default: "https://www.youtube.com/channel/UCQ0qt6fBplaws-x87Xrodlw",
    },
    instagram: {
      type: String,
      default: "https://www.instagram.com/techcast.gmbh",
    },
    linkedIn: {
      type: String,
      default: "https://de.linkedin.com/company/techcast-gmbh",
    },
  },
  data() {
    return {
      year: "",
    };
  },
  mounted() {
    this.year = new Date().getFullYear();
  },
  methods: {
    async removeAllCookies() {
      // remove 'cookies' from Youtube and Hubspot in the Local Storage
      localStorage.removeItem("acceptedYoutubePolicy");
      localStorage.removeItem("acceptedHubspotPolicy");

      // Get cookies, support window.cookieStore API or fallback to document.cookie
      let cookiesToDelete = [];
      if (window.cookieStore) {
        const allCookies = await window.cookieStore.getAll();
        allCookies.forEach((cookie) => {
          if (cookie && cookie.name) {
            cookiesToDelete.push(cookie.name);
          }
        });
      } else {
        // Parse document.cookie properly
        const cookies = document.cookie.split(";").map((c) => c.trim());
        cookies.forEach((cookieStr) => {
          const eqIdx = cookieStr.indexOf("=");
          const name = eqIdx > -1 ? cookieStr.substr(0, eqIdx) : cookieStr;
          cookiesToDelete.push(name);
        });
      }

      // Delete cookies starting with _ga (Google Analytics)
      cookiesToDelete = [
        ...new Set([
          ...cookiesToDelete,
          ...cookiesToDelete
            .filter((name) => name.startsWith("_ga"))
            .map((name) => name),
        ]),
      ];

      // Delete all cookies by name (with fallback for path and domain)
      cookiesToDelete.forEach((name) => {
        // Delete for path=/
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
        // Delete for path=/ and current domain
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${location.hostname};`;
      });

      // Delete cookies with window.cookieStore
      if (window.cookieStore) {
        for (const name of cookiesToDelete) {
          try {
            await window.cookieStore.delete(name);
          } catch (e) {
            console.log(e);
          }
        }
      }

      // Restore cookie_control_consent
      if (window.cookieStore) {
        await window.cookieStore.set("cookie_control_consent", true);
      } else {
        document.cookie = "cookie_control_consent=true; path=/";
      }

      // Reload the page to apply changes
      window.location.reload();
    },
  },
};
